import React from "react";
import { motion } from "framer-motion";

const containerVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: "easeOut",
    },
  },
};

const TreatmentCareGrid = ({ heading, grid }) => {
  return (
    <motion.section
      className="treatment-care container"
      variants={containerVariant}
      initial="hidden"
      whileInView="visible"
      viewport={{
        once: true,
        amount: 0.15,
      }}
    >
      <motion.p
        className="section-subheading"
        variants={fadeUp}
      >
        Comprehensive Ayurvedic Care
      </motion.p>

      <motion.h2
        className="section-heading"
        variants={fadeUp}
      >
        {heading}
      </motion.h2>

      <motion.div
        className="treatment-care-grid"
        variants={containerVariant}
      >
        {grid.map((item, i) => (
          <motion.div
            key={i}
            className="treatment-care-card"
            variants={cardVariant}
            whileHover={{
              y: -5,
            }}
            transition={{
              duration: 0.4,
            }}
          >
            <div
              style={{
                overflow: "hidden",
              }}
            >
              <motion.img
                src={item.img}
                alt={`${item.heading} | Dr. Jigar Gor's Ayurveda`}
                whileHover={{
                  scale: 1.05,
                }}
                transition={{
                  duration: 0.8,
                }}
              />
            </div>

            <div className="treatment-care-content">
              <h3 className="card-heading">
                {item.heading}
              </h3>

              <p className="section-text">
                {item.text}
              </p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </motion.section>
  );
};

export default TreatmentCareGrid;